<template>
  <div
    :id="pageId"
    :class="[
      'v-page',
      {
        '--no-scroll': noInnerScroll,
        '--no-bottom-padding': noPadding,
        '--white': white,
        '--dark-mode': darkMode
      }
    ]"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    noInnerScroll: { type: Boolean, default: false },
    noPadding: { type: Boolean, default: false },
    white: { type: Boolean, default: false },
    darkMode: { type: Boolean, default: false },
    pageId: { type: String, default: "" }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables";
@import "@/assets/styles/mixins";

.v-page {
  padding-bottom: 10rem;
  margin: 0 auto;
  background: $color-ui--grey-10;
  min-height: 100vh;

  &.--no-scroll {
    position: relative;
  }

  &.--white {
    background: $color-ui--white;
  }

  &.--no-bottom-padding {
    padding-bottom: 0;
  }
}
</style>

<style lang="scss">
@import "@/assets/styles/variables";

@media screen and (min-width: $breakpoint--xl) {
  .v-page {
    padding-left: $tabbar--desktop-width;

    [data-role="fixed-toolbar"].v-toolbar__wrapper .v-toolbar {
      padding-left: 250px;
    }

    .v-tabs {
      .v-page {
        padding-left: initial;
      }
    }
  }
}
</style>
